import { MDBIcon } from 'mdb-react-ui-kit';
import React, { useContext } from 'react';
import useResumeDiplomasHandlers from "../../../context/resume/hooks/resume-diplomas-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";
import { useCurrentUserRoles } from "../../../hooks/useCurrentUserRoles";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../../hooks/useResumeProperties";

export default function DiplomasPreview() {

    const { translations, displayLanguage, formatDate } = useContext( TranslationContext );
    const { isAlcyone, isEuropass, isAnonymous } = useResumeProperties();
    const { diplomas } = useResumeDocumentSection();
    const { handleRemove } = useResumeDiplomasHandlers();
    const { isManagerRole } = useCurrentUserRoles();

    return (
        <>
            { diplomas
                ?.sort( ( a, b ) => a.order - b.order )
                .map( ( diploma, index ) => (
                    <React.Fragment key={ index }>
                        { diploma && diploma.schoolName && (
                            <>
                                { isManagerRole && (
                                    <MDBIcon
                                        far
                                        icon="trash-alt"
                                        style={ {
                                            color: isAlcyone ? "#09B4BF" : "#0B86C8",
                                            fontSize: "11px",
                                            marginLeft: "-30px",
                                            fontWeight: 'bold'
                                        } }
                                        onClick={ () =>  window.confirm(translations.general.confirmationMessage) && handleRemove( diploma ) }
                                        role="button"
                                        size="lg"
                                    />
                                ) }
                            </>
                        ) }
                        <div
                            className="d-flex no-page-break"
                            style={ { marginTop: isManagerRole ? '-20px' : '0' } }
                        >
                            { !isEuropass && (
                                <div style={ { width: '15%', marginRight: '10px' } }>
                                    <p className="fw-bold mb-0 text-black" style={ {
                                        fontSize: "12px",
                                        color: isEuropass ? "#000000" : "#FF0000"
                                    } }>
                                        { isAnonymous && diploma.schoolName ? translations.pdf.diplomasSchoolLabel
                                            : diploma.schoolName }
                                    </p>
                                    { ( ( diploma.from || diploma.to || diploma.isCurrent ) && (
                                        <p className="mb-0 text-black" style={ { fontSize: "11px" } }>
                                            { diploma.from ? formatDate( diploma.from ) : "" }
                                            { diploma.from && ( diploma.to || diploma.isCurrent )
                                                ? " - "
                                                : "" }
                                            { diploma.isCurrent
                                                ? translations.pdf.isCurrentLabel
                                                : ( diploma.to ? formatDate( diploma.to ) : "" ) }
                                        </p>
                                    ) ) }
                                </div>
                            ) }
                            <div className={ isEuropass ? "w-100" : "w-75" }
                                 style={ { fontSize: "12px", textAlign: "justify" } }
                            >
                                { isEuropass && (
                                    ( ( diploma.from || diploma.to || diploma.isCurrent ) ) && (
                                        <p className={ isEuropass ? "mb-0" : "mb-0 text-black" }
                                           style={ { fontSize: isEuropass ? "9px" : "11px" } }
                                        >
                                            { diploma.from ? formatDate( diploma.from ) : "" }
                                            { diploma.from && ( diploma.to || diploma.isCurrent ) ? " - " : "" }
                                            { diploma.isCurrent
                                                ? translations.pdf.isCurrentLabel
                                                : (
                                                    diploma.to
                                                        ? formatDate( diploma.to )
                                                        : ""
                                                ) }
                                        </p>
                                    )
                                ) }
                                { !isEuropass && (
                                    <p className="mb-0"
                                       style={ { color: isAlcyone ? "#09B4BF" : "#0B86C8" } }
                                    >{ diploma.educationLevel?.translations?.[ displayLanguage ] }</p>
                                ) }
                                <div className="d-flex align-items-center gap-2">
                                    <p className={ isEuropass ? "" : "text-black" }
                                       style={ {
                                           margin: isEuropass && "0px",
                                           textTransform: isEuropass && "uppercase"
                                       } }
                                    >{ diploma.diplomaTitle }</p>
                                    { isEuropass && (
                                        <p className={ isEuropass ? "mb-0" : "fw-bold mb-0 text-black" }
                                           style={ {
                                               color: isEuropass ? "#000000" : "#FF0000"
                                           } }
                                        >{
                                            ( isAnonymous && diploma.schoolName )
                                                ? translations.pdf.diplomasSchoolLabel
                                                : diploma.schoolName
                                        }</p>
                                    ) }
                                </div>
                                { isEuropass && (
                                    <hr style={ {
                                        color: "#979797",
                                        height: "2px",
                                        width: "100%",
                                        marginLeft: "0px",
                                        marginBottom: "20px",
                                        marginTop: "4px"
                                    } }/>
                                ) }
                            </div>
                        </div>
                        { index < diploma.length - 1 && (
                            ( diploma.schoolName || diploma.diplomaTitle ) &&
                            ( diploma[ index + 1 ].schoolName || diploma[ index + 1 ].diplomaTitle ) && (
                                <hr style={ { color: isAlcyone ? "#09B4BF" : "#0B86C8" } }/>
                            )
                        ) }
                    </React.Fragment>
                ) )
            }
        </>
    );
}
